import React from 'react';
import './bookmark.css';
const Bookmark = ({ children }) => {
	return (
		<React.Fragment>
			<div className="bookmark-container">{children}</div>
		</React.Fragment>
	);
};

export default Bookmark;
